import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-device-status-message',
  templateUrl: './device-status-message.component.html',
  styleUrls: ['./device-status-message.component.scss']
})
export class DeviceStatusMessageComponent {
  @Input() deviceUrl: string | null = null;
}
